import React from 'react';
import PropTypes from 'prop-types';
import ClientLeadStatusView from './ClientLeadStatusView';
import ClientLeadStatusEdit from './ClientLeadStatusEdit';

const ClientLeadStatus = (props) => {
  const [isEditing, setIsEditing] = React.useState(false);

  const {
    clientLeadData,
    clientLeadBackend,
  } = props;

  return (
    <>
      <ClientLeadStatusView
        clientLeadData={clientLeadData}
        clientLeadBackend={clientLeadBackend}
        isEditing={isEditing}
        setIsEditing={setIsEditing}
      />
      {
        isEditing &&
        <ClientLeadStatusEdit
          clientLeadData={clientLeadData}
          clientLeadBackend={clientLeadBackend}
          isEditing={isEditing}
          setIsEditing={setIsEditing}
        />
      }
    </>
  );
};

ClientLeadStatus.propTypes = {
  clientLeadData: PropTypes.object.isRequired,
  clientLeadBackend: PropTypes.object.isRequired,
};

export default React.memo(ClientLeadStatus);
